import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { DETAILS_TAB, PAY_TAB, QUOTE_TAB } from '../../tabs';
import { Button, ButtonBar } from '../../../../../../common/components';
import YourDetailsTab from './YourDetailsTab/YourDetailsTab';
import QuoteTab from './QuoteTab/QuoteTab';
import PayTab from './PayTab/PayTab';
import './QuoteTabsContainer.scss';

const QuoteTabsContainer = ({
  productCode,
  isMta,
  isSaving,
  handleTab,
  handleNextTab,
  handlePreviousTab,
  activeTab,
  groupType,
  calculatedPremiums,
  purchaseDeclaration,
  directDebitQuestions,
  handleIssuePolicy,
  finalPremium,
  issuingError,
  paymentDeclarations,
  productId,
  rules,
}) => {
  return (
    <Tabs
      unmountOnExit
      id="personal-accident"
      onSelect={handleTab}
      activeKey={activeTab}
      className={'pa-quote-tabs-container'}
    >
      <Tab
        eventKey={DETAILS_TAB}
        title={
          <div className="number-tabs">
            <span className={activeTab === DETAILS_TAB ? 'active-tab' : 'inactive-tab'}>
              {DETAILS_TAB <= activeTab ? (
                <span className={'number number-seen'}>{DETAILS_TAB}</span>
              ) : (
                <span className={'number number-not-seen'}>{DETAILS_TAB}</span>
              )}{' '}
              Your Details
            </span>
          </div>
        }
      >
        <YourDetailsTab groupType={groupType} productCode={productCode} rules={rules} />
        {groupType && (
          <ButtonBar>
            <Button
              label="Next"
              bsStyle="primary"
              isLoading={isSaving}
              className={'pull-right'}
              handleClick={handleNextTab}
            />
          </ButtonBar>
        )}
      </Tab>
      <Tab
        eventKey={QUOTE_TAB}
        title={
          <div className="number-tabs">
            <span className={activeTab === QUOTE_TAB ? 'active-tab' : 'inactive-tab'}>
              {QUOTE_TAB <= activeTab ? (
                <span className={'number number-seen'}>{QUOTE_TAB}</span>
              ) : (
                <span className={'number number-not-seen'}>{QUOTE_TAB}</span>
              )}{' '}
              Quote
            </span>
          </div>
        }
      >
        <QuoteTab
          calculatedPremiums={calculatedPremiums}
          isSaving={isSaving}
          productId={productId}
          productCode={productCode}
        />
        <ButtonBar>
          <Button
            label="Back"
            bsStyle="secondary"
            className="pull-left"
            handleClick={handlePreviousTab}
          />
          <Button
            label="Next"
            bsStyle="primary"
            isLoading={isSaving}
            className={'pull-right'}
            handleClick={handleNextTab}
          />
        </ButtonBar>
      </Tab>
      <Tab
        eventKey={PAY_TAB}
        title={
          <div className="number-tabs">
            <span className={activeTab === PAY_TAB ? 'active-tab' : 'inactive-tab'}>
              {PAY_TAB <= activeTab ? (
                <span className={'number number-seen'}>{PAY_TAB}</span>
              ) : (
                <span className={'number number-not-seen'}>{PAY_TAB}</span>
              )}{' '}
              Payment
            </span>
          </div>
        }
      >
        <PayTab
          purchaseDeclaration={purchaseDeclaration}
          directDebitQuestions={directDebitQuestions}
          paymentDeclarations={paymentDeclarations}
          finalPremium={finalPremium}
          issuingError={issuingError}
          isMta={isMta}
          productCode={productCode}
          rules={rules}
        />
        <ButtonBar>
          <Button
            label="Back"
            bsStyle="secondary"
            className="pull-left"
            handleClick={handlePreviousTab}
          />
          <Button
            label="Apply for Cover"
            bsStyle="primary"
            isLoading={isSaving}
            className={'pull-right'}
            handleClick={handleIssuePolicy}
            //  disabled={!!issuingError}
          />
        </ButtonBar>
      </Tab>
    </Tabs>
  );
};

export default QuoteTabsContainer;
